exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-7ef80078] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\n.filter-item[data-v-7ef80078] {\r\n    margin-right: 10px;\r\n    margin-top: 10px;\n}\n.pagination-container[data-v-7ef80078] {\r\n  background: #fff;\r\n  padding: 20px 16px;\n}\n.pagination-container.hidden[data-v-7ef80078] {\r\n  display: none;\n}\r\n", ""]);

// exports
